import type { ComponentProps } from "react";

export function Plus(props: ComponentProps<"svg">) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			fill="currentColor"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.9 7.819a.9.9 0 0 0-1.8 0v2.882a.4.4 0 0 1-.4.4H7.818a.9.9 0 1 0 0 1.8H10.7c.22 0 .4.18.4.4v2.881a.9.9 0 1 0 1.8 0v-2.881c0-.22.179-.4.4-.4h2.882a.9.9 0 0 0 0-1.8H13.3a.4.4 0 0 1-.4-.4V7.819Z"
				opacity={0.9}
			/>
		</svg>
	);
}
